export enum BookingDialogType {
  Tickets,
  Uploads
}
